import AisleHeatmappingSetup from './aisleHeatmapping/PluginSetup'
import AlertsSetup from './alerts/PluginSetup'
import AnalyticsSetup from './analytics/PluginSetup'
import EventsActionSetup from './events/actions/PluginSetup'
import RoomOccupancySetup from './roomOccupancy/PluginSetup'
import ShelfMonitoringSetup from './shelfMonitoring/PluginSetup'
import StationCardSetup from './stationCard/PluginSetup'
import StationTimelineEventsSetup from './stationTimeline/PluginSetup'
import StoreTrafficSetup from './storeTraffic/PluginSetup'

export default {
  install( molten ) {
    AnalyticsSetup.install( molten )
    StationCardSetup.install( molten )
    StationTimelineEventsSetup.install( molten )
    EventsActionSetup.install( molten )
    StoreTrafficSetup.install( molten )
    RoomOccupancySetup.install( molten )
    AisleHeatmappingSetup.install( molten )
    ShelfMonitoringSetup.install( molten )
    AlertsSetup.install( molten )
  }
}
